import Menu from "./Menu";

const HorizontalCategory = (props) => {

    let list = props.list ? props.list : [];

    return (
        <>
        <div className="d-flex d-row-dir">
            {
                list.map((element,index) => {
                    return <Menu callback={props.callback} key={index} data={element} selected={element === props.current} />;
                })
            }
        </div>
        </>
    );
}

export default HorizontalCategory;